import { render } from "./SimpleLoading.vue?vue&type=template&id=73044a26&scoped=true"
const script = {}

import "./SimpleLoading.vue?vue&type=style&index=0&id=73044a26&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73044a26"]])

export default __exports__